export function commonThousandths(val) {
  // add camma to number
  let num = val?.toLocaleString();
  return num;
}
